/**
 * How strongly a zoom-rail cell is drawn, as a step in a fixed ramp.
 *
 * The rail is chrome, not a second plot: it grades one neutral so the eye can
 * find the heavy hours without competing with the coloured bars above it.
 */
export const RAIL_STEP_EMPTY = 0;
export const RAIL_STEP_MIN = 1;
export const RAIL_STEP_MAX = 4;

/** Share of the window's busiest bucket at which each step takes over. */
const STEP_THRESHOLDS = [0.75, 0.5, 0.25] as const;

export function railStep(
  point: { queries: number; bytesBilled: number },
  maxBytesBilled: number,
): number {
  // A bucket nothing ran in is the one case that is not a magnitude at all.
  if (point.queries === 0) return RAIL_STEP_EMPTY;

  // Queries that billed nothing still ran: a cache hit bills zero bytes, and a
  // window of nothing but hits must not read as an idle one.
  if (point.bytesBilled === 0 || maxBytesBilled <= 0) return RAIL_STEP_MIN;

  const share = point.bytesBilled / maxBytesBilled;
  const passed = STEP_THRESHOLDS.findIndex((threshold) => share > threshold);
  return passed === -1 ? RAIL_STEP_MIN : RAIL_STEP_MAX - passed;
}

export function maxBytesBilled(points: readonly { bytesBilled: number }[]): number {
  return points.reduce((max, point) => Math.max(max, point.bytesBilled), 0);
}
